export const getCompanyShortForm = (companyName) => {
  const ignoreWords = ['AND', 'PTE', 'PVT', 'LTD', 'PRIVATE', 'LIMITED'];

  // Normalize all whitespace (e.g., non-breaking space to normal space)
  const normalized = companyName.replace(/\s+/g, ' ').replace(/\u00A0/g, ' ').trim();

  const words = normalized
    .toUpperCase()
    .split(' ')
    .filter(word => word && !ignoreWords.includes(word));

  const initials = [];

  for (const word of words) {
    if (initials.length >= 3) break;

    if (word.length <= 3 && /^[A-Z]+$/.test(word)) {
      for (const char of word) {
        if (initials.length < 3) initials.push(char);
      }
    } else {
      initials.push(word[0]);
    }
  }

  return initials.join('');
};
